<template>
    <div>
        <zm-form inline>
            <zm-form-item>
                <div slot="label">
                    <tip label="Dc" id="smart-client-query-dc"></tip>
                </div>
                <zm-select size="small" v-model="params.dc" placeholder="dc" clearable>
                    <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="Has Tag" id="smart-client-query-hasTag"></tip>
                </div>
                <zm-select size="small" v-model="params.hasTag" placeholder="">
                    <zm-option :value="undefined" label="all"></zm-option>
                    <zm-option :value="true" label="has tag"></zm-option>
                    <zm-option :value="false" label="no tag"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item prop="poolId">
                <div slot="label">
                    <tip label="Region" id="smart-client-query-poolId"></tip>
                </div>
                <zm-select size="small" v-model="params.poolId" placeholder="region" clearable style="width: 120px">
                    <zm-option v-for="item in poolList" :key="item.id" :label="item.name" :value="item.id"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item>
                <div slot="label"><tip label="Client Name" id="smart-client-query-clientName"></tip></div>
                <zm-input size="small" v-model.trim="params.clientName" placeholder="clientName" @keyup.enter.native="fetchData" clearable></zm-input>
            </zm-form-item>
            <!-- <zm-form-item>
                <div slot="label"><tip label="dc" id="smart-client-query-dc"></tip></div>
                <zm-input size="small" v-model.trim="params.dc" placeholder="dc" @keyup.enter.native="fetchData" clearable></zm-input>
            </zm-form-item> -->
            <zm-form-item>
                <div slot="label"><tip label="Host Name" id="smart-client-query-hostName"></tip></div>
                <zm-input size="small" v-model.trim="params.hostName" placeholder="hostName" @keyup.enter.native="fetchData" clearable></zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label"><tip label="Ip" id="smart-client-query-ip"></tip></div>
                <zm-input size="small" v-model.trim="params.ip" placeholder="ip" @keyup.enter.native="fetchData" clearable></zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label"><tip label="RequestIp" id="smart-client-query-requestIp"></tip></div>
                <zm-input size="small" v-model.trim="params.requestIp" placeholder="requestIp" @keyup.enter.native="fetchData" clearable></zm-input>
            </zm-form-item>
            <zm-form-item>
                <zm-button type="icon" size="small" icon="zm-icon-search" @click="fetchData()" :loading="loading"></zm-button>
            </zm-form-item>
        </zm-form>
        <zm-button size="small" @click="showSet()" class="btn-in-line" type="primary" plain v-if="hasPermission">set tags</zm-button>
        <zm-button size="small" @click="showDelete()" class="btn-in-line" type="danger" plain v-if="hasPermission">delete tags</zm-button>
        <zm-table :data="list"
        @selection-change="handleSelectionChange" v-loading="loading" :init-displayed-column="initDisplayedColumn">
            <zm-table-column prop="selection" type="selection" width="55" v-if="hasPermission"></zm-table-column>
            <zm-table-column prop="id" label="Id"></zm-table-column>
            <zm-table-column prop="requestIp" label="Request Ip"></zm-table-column>
            <zm-table-column prop="ip" label="Ip"></zm-table-column>
            <zm-table-column prop="poolName" label="Region"></zm-table-column>
            <zm-table-column prop="clientName" label="Client Name"></zm-table-column>
            <zm-table-column prop="hostName" label="Host Name"></zm-table-column>
            <zm-table-column label="Tags" prop="tags">
                <template slot-scope="scope">
                    <zm-tag v-for="item in scope.row.tags" :key="item" type="" size="mini">{{ item }}</zm-tag>
                </template>
            </zm-table-column>
            <zm-table-column prop="globalHandlers" label="Global Handlers">
                <template slot-scope="scope">
                    <zm-tooltip placement="right"
                    v-if="scope.row.globalHandlers && scope.row.globalHandlers.length">
                        <div slot="content">
                            <p v-for="item in scope.row.globalHandlers" :key="item">{{ item }}</p>
                        </div>
                        <zm-tag size="medium" type="">show</zm-tag>
                    </zm-tooltip>
                    <span v-else></span>
                </template>
            </zm-table-column>
            <zm-table-column prop="createdTime" label="Created Time" :formatter="setTime"></zm-table-column>
            <zm-table-column prop="modifiedTime" label="Modified Time" :formatter="setTime"></zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
            @size-change="handleSizeChange"
                :current-page.sync="params.page" :page-size="params.size"
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                :total="params.total">
            </zm-pagination>
        </div>
        <zm-dialog title="Set Tags" :visible.sync="visible">
            <zm-form ref="form" :model="form" label-width="120px" :rules="rules">
                <zm-form-item prop="poolId">
                    <div slot="label">
                        <tip label="Pool" id="smart-client-poolId"></tip>
                    </div>
                    <zm-select size="small" v-model="form.poolId" style="width: 100%">
                        <zm-option v-for="item in poolList" :key="item.id" :label="item.name" :value="item.id"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="tags">
                    <div slot="label">
                        <tip label="Tags" id="smart-client-tags"></tip>
                    </div>
                    <zm-checkbox-group size="small" v-model="form.tags">
                        <zm-checkbox v-for="item in tags" :key="item"
                            :label="item" :value="item"></zm-checkbox>
                    </zm-checkbox-group>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="form.isOverride">
                        <tip label="Is Override" id="smart-client-isOverride"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listPool, listServiceById, searchServiceClients, setTags, deleteTags } from '@/api/smart'
import { getChannelDcs } from '@/api'
import tip from 'components/ToolTip/index'
export default {
    name: 'client',
    components: {
        tip
    },
    data () {
        return {
            initDisplayedColumn: {
                key: 'smartclient',
                props: ['selection', 'id', 'ip', 'hostName', 'tags', 'globalHandlers', 'requestIp', 'clientName', 'createdTime', 'modifiedTime']
            },
            role: localStorage.role,
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false,
            serviceId: '',
            dcs: [],
            list: [],
            poolList: [],
            tags: [],
            visible: false,
            form: {
                poolId: '',
                isOverride: false,
                clientIds: [],
                tags: []
            },
            ids: [],
            params: {
                id: '',
                dc: '',
                clientName: '',
                hostName: '',
                ip: '',
                poolId: '',
                requestIp: '',
                hasTag: undefined,
                page: 1,
                size: 10,
                total: 0
            },
            rules: {
                poolId: [
                    { required: true, message: 'please select a pool', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.serviceId = this.$route.params.id
        this.fetchDcs()
        this.fetchPools()
        this.fetchTags()
        this.fetchData()
    },
    methods: {
        handleSizeChange (val) {
            this.params.size = val
            this.fetchData()
        },
        handleSelectionChange (val) {
            this.ids = []
            val.map(item => {
                this.ids.push(item.id)
            })
        },
        setTime (row, column, cellValue, index) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        fetchDcs () {
            getChannelDcs().then(response => {
                this.dcs = response
            })
        },
        fetchTags () {
            listServiceById(this.serviceId).then(response => {
                this.tags = response.tags
            })
        },
        fetchPools () {
            this.loading = true
            listPool(this.serviceId).then(response => {
                this.poolList = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        showSet () {
            this.form.poolId = ''
            this.form.isOverride = false
            this.form.tags = []
            this.form.clientIds = this.ids
            this.visible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    setTags(this.form).then(() => {
                        this.loading = false
                        this.visible = false
                        this.fetchData()
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        showDelete () {
            this.$confirm('This will delete the tags. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteTags(this.ids).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        fetchData () {
            this.loading = true
            const params = {
                size: this.params.size,
                page: this.params.page - 1
            }
            searchServiceClients(this.serviceId, this.params, params).then(response => {
                const { content, total } = response
                this.list = content.map(item => {
                    const data = item.result
                    data.tags = item.tags
                    data.poolName = item.poolName
                    return data
                })
                this.params.total = total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>
